import { createSlice } from "@reduxjs/toolkit";

const SUPPORTED = ["en", "fr", "es", "pt"];

const detectBrowserLanguage = () => {
  const saved = JSON.parse(localStorage.getItem("language"));
  if (saved && SUPPORTED.includes(saved)) return saved;
  const browserLang = (navigator.language || navigator.userLanguage || "en").slice(0, 2).toLowerCase();
  const detected = SUPPORTED.includes(browserLang) ? browserLang : "en";
  localStorage.setItem("language", JSON.stringify(detected));
  return detected;
};

const languageSlice = createSlice({
  name: "language",
  initialState: detectBrowserLanguage(),
  reducers: {
    setLanguage: (state, action) => {
      // console.log("setLanguage SLICE", state, action);
      // state = action.payload;
      return action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;